export const checkValidPosition = position => {
    return (
        position !== null &&
        position !== '' &&
        !isNaN(position?.lat) &&
        !isNaN(position?.lng)
    )
}
